/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TitlesInputs */

const en_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITLES`)
};

const fr_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITRES`)
};

const de_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITEL`)
};

const it_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TITOLI`)
};

const ru_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`НАЗВАНИЯ`)
};

const es_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TÍTULOS`)
};

const zh_cn2_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const ja_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const hi_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिताब`)
};

const pt_pt2_ccsl_export_header_titles = /** @type {(inputs: Ccsl_Export_Header_TitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TÍTULOS`)
};

/**
* | output |
* | --- |
* | "TITLES" |
*
* @param {Ccsl_Export_Header_TitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_titles = /** @type {((inputs?: Ccsl_Export_Header_TitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_titles(inputs)
	if (locale === "de") return de_ccsl_export_header_titles(inputs)
	if (locale === "it") return it_ccsl_export_header_titles(inputs)
	if (locale === "ru") return ru_ccsl_export_header_titles(inputs)
	if (locale === "es") return es_ccsl_export_header_titles(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_titles(inputs)
	if (locale === "ja") return ja_ccsl_export_header_titles(inputs)
	if (locale === "hi") return hi_ccsl_export_header_titles(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_titles(inputs)
	return en_ccsl_export_header_titles(inputs)
});